import { takeEvery, fork, put, all, call } from "redux-saga/effects"

import { ForgetPwdTypes } from "./actionTypes"
import { userForgetPasswordSuccess, userForgetPasswordError } from "./actions"

import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  postFakeForgetPwd,
  postJwtForgetPwd,
} from "../../../helpers/fakebackend_helper"
import { sendPasswordResetEmail } from "../../../helpers/wordpress_password"

const fireBaseBackend = getFirebaseBackend()

function* forgetUser({ payload: { user } }: any) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      yield call(fireBaseBackend.forgetPassword, user.email)
      yield put(
        userForgetPasswordSuccess(
          "Reset link has been sent to your mailbox. Please check there first."
        )
      )
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      yield call(postJwtForgetPwd, { email: user.email })
      yield put(
        userForgetPasswordSuccess(
          "Reset link has been sent to your mailbox. Please check there first."
        )
      )
    } else if (process.env.REACT_APP_DEFAULTAUTH === "wordpress") {
      yield call(sendPasswordResetEmail, user.email)
      yield put(
        userForgetPasswordSuccess(
          "If an account exists for that email, a password reset link has been sent. Please check your inbox (and spam folder)."
        )
      )
    } else {
      yield call(postFakeForgetPwd, { email: user.email })
      yield put(
        userForgetPasswordSuccess(
          "Reset link has been sent to your mailbox. Please check there first."
        )
      )
    }
  } catch (error: any) {
    const message =
      error instanceof Error
        ? error.message
        : typeof error === "string"
          ? error
          : "Unable to send password reset email."
    yield put(userForgetPasswordError(message))
  }
}

export function* watchUserPasswordForget() {
  yield takeEvery(ForgetPwdTypes.FORGET_PASSWORD, forgetUser)
}

function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget)])
}

export default forgetPasswordSaga
